import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import './styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import './i18n';
import { App } from './App';
render(_jsx(App, {}), document.getElementById('root'));
